import { Button, Col, Container, Form, Row } from "react-bootstrap";
import "../css/contact.css";
import { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

export const Contact = () => {

   useEffect(() => {
        Aos.init({ duration: 1000 })
    })

    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
    };

    return (
        <>
            {/* Header Section */}
            <Container
                fluid
                className="gallery-header d-flex justify-content-start align-items-center"
            >
                <Row>
                    <Col data-aos="fade-up" data-aos-delay="100">
                        <h1 className="gallery-title">Contact Us</h1>
                    </Col>
                </Row>
            </Container>

            {/* Body Section */}
            <Container fluid className="contact-body">
                {/* 👇 Added class for visible horizontal spacing */}
                <Row className="contact-row">
                    {/* LEFT SIDE: ADDRESS */}
                    <Col md={6} className="contact-info">
                        <h1 style={{
                            color:"#850814"
                        }}>Office Address</h1>

                        <p style={{
                            fontWeight:"600"
                        }}>
                            Kharbi Chowk, Sakharkar Nagar, West Ring Road, Nagpur
                        </p>

                        <Row>
                            <Col md={6} xs={12} className="mb-3">
                                <p className="contact-label">Email :-</p>
                                <p className="contact-data"> bhadadegroup@gmail.com</p>
                            </Col>

                            <Col md={6} xs={12}>
                                <p className="contact-label">Phone :-</p>
                                <p className="contact-data">
                                    <a href="tel:+919923314198" style={{ color: "inherit", textDecoration:"none" }}>
                                        9923314198 /
                                        8329775561
                                    </a>
                                </p>
                            </Col>
                        </Row>
                    </Col>

                    {/* RIGHT SIDE: FORM */}
                    <Col md={6} className="contact-form-wrapper">
                        <div className="form-header text-center">
                            <p style={{
                                fontWeight:"600"
                            }}>Book Us</p>
                            <h2 style={{
                                color:"#850814",
                                fontWeight:"600"
                            }}>Where You Want Our Services</h2>
                        </div>

                        <Form
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                            className="contact-form"
                        >
                            <Form.Group controlId="validationCustom01" className="mb-3">
                                <Form.Label>Full Name</Form.Label>
                                <Form.Control required type="text" placeholder="Enter your name" />
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="validationCustom03" className="mb-3">
                                <Form.Label>City</Form.Label>
                                <Form.Control type="text" placeholder="City" required />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid city.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="validationCustom04" className="mb-3">
                                <Form.Label>State</Form.Label>
                                <Form.Control type="text" placeholder="State" required />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid state.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="validationCustom05" className="mb-3">
                                <Form.Label>Zip</Form.Label>
                                <Form.Control type="text" placeholder="Zip" required />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid zip.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="message" className="mb-3">
                                <Form.Label>Your Message</Form.Label>
                                <Form.Control as="textarea" rows={3} placeholder="Enter your message" />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Check
                                    required
                                    label="Agree to terms and conditions"
                                    feedback="You must agree before submitting."
                                    feedbackType="invalid"
                                />
                            </Form.Group>

                            <div className="d-flex justify-content-center">
                                <Button type="submit" className="submit-btn">
                                    Submit Form
                                </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
